<template>
	<section>
		<div class="footer">
            <router-link :to="{path:'home'}" class="footer_btn">
                <div class="footer_icon_home"></div>
                <div class="footer_text">答题</div>
            </router-link>
            <router-link :to="{path:'practice'}" class="footer_btn">
                <div class="footer_icon_practice"></div>
                <div class="footer_text">我的练习</div>
            </router-link>
            <router-link :to="{path:'mistake'}" class="footer_btn">
                <div class="footer_icon_mistake"></div>
                <div class="footer_text">我的错题</div>
            </router-link>
            <router-link :to="{path:'collection'}" class="footer_btn">
                <div class="footer_icon_collection"></div>
                <div class="footer_text">我的收藏</div>
            </router-link>
            <router-link :to="{path:'notDone'}" class="footer_btn">
                <div class="footer_icon_practice"></div>
                <div class="footer_text">未完成</div>
            </router-link>
		</div>
	</section>
</template>
<script>
	export default {
		data() {
			return {

			}
        },
        mounted() {
			
		},
		methods: {
			
		}
	}

</script>

<style>
.footer{
    width: 1200px;
    height: 80px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
}
.footer .footer_btn{
    width: 70px;
    height: 64px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    cursor: pointer
}
.footer .footer_btn .footer_icon{
    width: 32px;
    height: 32px;
}
.footer .footer_btn .footer_icon_home{
    width: 30px;
    height: 30px;
    background-image: url('../assets/images/icon_home.png');
}
.footer .footer_btn.router-link-active .footer_icon_home{
    background-image: url('../assets/images/icon_home_active.png');
}
.footer .footer_btn .footer_icon_practice{
    width: 25px;
    height: 28px;
    background-image: url('../assets/images/icon_practice.png');
}
.footer .footer_btn.router-link-active .footer_icon_practice{
    background-image: url('../assets/images/icon_practice_active.png');
}
.footer .footer_btn .footer_icon_mistake{
    width: 29px;
    height: 29px;
    background-image: url('../assets/images/icon_mistake.png');
}
.footer .footer_btn.router-link-active .footer_icon_mistake{
    background-image: url('../assets/images/icon_mistake_active.png');
}
.footer .footer_btn .footer_icon_collection{
    width: 29px;
    height: 27px;
    background-image: url('../assets/images/icon_collection.png');
}
.footer .footer_btn.router-link-active .footer_icon_collection{
    background-image: url('../assets/images/icon_collection_active.png');
}
.footer .footer_btn .footer_text{
    width: 70px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    color: #fff4ec;
}
.footer .footer_btn.router-link-active .footer_text{
    color: #fbfd6b
}
a,
a:link,
a:visited,
a:hover,
a:active {
    text-decoration: none;
}
</style>